import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Empresas API
export const empresasApi = {
  getAll: () => api.get('/empresas'),
  getOne: (id) => api.get(`/empresas/${id}`),
  update: (id, data) => api.put(`/empresas/${id}`, data),
  getUsuarios: (empresaId) => api.get(`/empresas/${empresaId}/usuarios`),
  addUsuario: (empresaId, email, rol) => api.post(`/empresas/${empresaId}/usuarios`, null, { params: { email, rol } }),
  removeUsuario: (empresaId, usuarioId) => api.delete(`/empresas/${empresaId}/usuarios/${usuarioId}`),
};

// Clientes API
export const clientesApi = {
  getAll: (empresaId) => api.get('/clientes', { params: { empresa_id: empresaId } }),
  getOne: (id) => api.get(`/clientes/${id}`),
  create: (data) => api.post('/clientes', data),
  update: (id, data) => api.put(`/clientes/${id}`, data),
  delete: (id) => api.delete(`/clientes/${id}`),
};

// Presupuestos API
export const presupuestosApi = {
  getAll: (empresaId, estado) => api.get('/presupuestos', { params: { empresa_id: empresaId, estado } }),
  getOne: (id) => api.get(`/presupuestos/${id}`),
  create: (data) => api.post('/presupuestos', data),
  update: (id, data) => api.put(`/presupuestos/${id}`, data),
  delete: (id) => api.delete(`/presupuestos/${id}`),
  enviar: (id) => api.post(`/presupuestos/${id}/enviar`),
  duplicar: (id) => api.post(`/presupuestos/${id}/duplicar`),
};

// Dashboard API
export const dashboardApi = {
  getMetricas: (empresaId) => api.get('/dashboard/metricas', { params: { empresa_id: empresaId } }),
};

// Public API (no auth)
export const publicApi = {
  getPresupuesto: (enlace) => axios.get(`${API_URL}/public/presupuesto/${enlace}`),
  responder: (enlace, accion, comentario) => axios.post(`${API_URL}/public/presupuesto/${enlace}/responder`, null, { params: { accion, comentario } }),
};

// Planes API
export const planesApi = {
  getAll: () => api.get('/planes'),
};

// Seed API
export const seedApi = {
  seed: () => api.post('/seed'),
};

export default api;
